import Splide from '@splidejs/splide';

var splide = document.getElementsByClassName('splide');

if (splide.length > 0) {
    new Splide('.splide', {
        perPage: 3,
        gap: '1rem',
        pagination: false,
        rewind: true,
        breakpoints: {
            568: {
                perPage: 1,
            },
            768: {
                perPage: 2,
            },
            1024: {
                perPage: 2,
            },
        },
    }).mount();
}
